import { render, staticRenderFns } from "./KamsContainer.vue?vue&type=template&id=5851133c&scoped=true"
import script from "./KamsContainer.vue?vue&type=script&lang=js"
export * from "./KamsContainer.vue?vue&type=script&lang=js"
import style0 from "./KamsContainer.vue?vue&type=style&index=0&id=5851133c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5851133c",
  null
  
)

export default component.exports